module.exports = __webpack_public_path__ + "static/img/organism-h5-7.cba67d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/organism-h5-7.png
// module id = Z5SD
// module chunks = 34